export default __webpack_public_path__ + "static/media/js-brands.70ba18a3.svg";